import React, { useEffect, useRef, useState } from 'react'
import { useSelector } from 'react-redux'
import { Overlay, Table, Tooltip } from 'react-bootstrap'

import { RootState } from '../../store'
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome'
import { isSmallMobileQuery } from '../../utils'
import { useMediaQuery } from 'react-responsive'
import { IRegistration } from '../../store/registrations/interfaces'
import { calculateCustomPrice } from '../../store/registrations/registrations'


const PaymentDetails = (props: {
  registrations: IRegistration[],
  isVerifyStage?: boolean
}) => {
  const {registrations, isVerifyStage} = props
  const {
    basic_fee,
    payment_configuration: { smallprint },
  } = useSelector((state: RootState) => state.program.data)

  const {
    discountCodes,
  } = useSelector((state: RootState) => state.paymentData)

  const {
    data: program,
  } = useSelector((state: RootState) => state.program)

  const [show, setShow] = useState(false)
  const [regs, setRegs] = useState(registrations);
  const target = useRef<HTMLSpanElement>(null)

  const isSmallMobile = useMediaQuery(isSmallMobileQuery)

  useEffect(() => {
    setRegs(regs.map((r) => {
      const customPrice = calculateCustomPrice(r, discountCodes, program)
      return {...r, customPrice: customPrice > 0 ? customPrice : 0}
    }))
  },[discountCodes.length])

  return (
    <>
      <Table responsive>
        <tbody>
        <tr>
          <th>Anmeldung</th>
          <th>Preis</th>
        </tr>
        {regs.map((reg: IRegistration, key: number) => (
          <tr key={key}>
            <td>
              {reg.event.name} (#{reg.event.event_id})
              {reg.event.has_external_payment && (
                <small className='text-muted'>
                  <br />
                  beim Veranstalter zu bezahlen
                </small>
              )}
            </td>
            <td
              className={
                reg.event.has_external_payment || reg.price === 0
                  ? 'text-muted pull-right'
                  : 'pull-right'
              }
            >
              {reg.customPrice ? <p>{reg.customPrice.toFixed(2)}€ <s className="text-danger">{reg.price.toFixed(2)}€</s></p> : <p>{reg.price.toFixed(2)}€</p>}
            </td>
          </tr>
        ))}
        {basic_fee > 0 && (
          <tr>
            <td>
              Grundgebühr{' '}
              <small>
                  <span
                    className='badge bg-dark text-white'
                    ref={target}
                    onClick={() => setShow(!show)}
                  >
                    <FontAwesomeIcon icon='question' />
                  </span>
                {target && target.current && (
                  <Overlay
                    target={target.current}
                    show={show}
                    placement={isSmallMobile ? 'bottom' : 'right'}
                  >
                    {(props: any) => (
                      <Tooltip {...props}>
                        Die Grundgebühr fällt nur einmal pro Teilnehmer an,
                        wenn mindestens eine Anmeldung akzeptiert wird.
                      </Tooltip>
                    )}
                  </Overlay>
                )}
              </small>
            </td>
            <td className='pull-right'>{basic_fee.toFixed(2)}€</td>
          </tr>
        )}
        <tr className='payment-total'>
          <td>
            <strong>Summe</strong>&nbsp;
            <small className='text-muted'>
              nur die Kosten bei der Institution
            </small>
          </td>
          <td className='pull-right'>
            {regs
              .filter((reg: IRegistration) => !reg.event.has_external_payment)
              .reduce((sum: number, eReg: IRegistration) => sum + (eReg.customPrice || eReg.price), basic_fee)
              .toFixed(2)}
            €
          </td>
        </tr>
        </tbody>
      </Table>
      <small className='text-muted'>
        <strong>Beachten Sie: </strong>
        Die aufgelisteten Beträge sind vorläufig und gelten nur für den Fall,
        dass jede Anmeldung auch zugeteilt wird. Die letztendlich zu zahlenden
        Kosten stehen erst nach erfolgter Zuteilung fest.
      </small>
      {smallprint && (
        <div className='mt-3'>
          <strong>Hinweise</strong>
          <div dangerouslySetInnerHTML={{ __html: smallprint }} />
        </div>
      )}
      {discountCodes && discountCodes.length > 0 && isVerifyStage && (
        <>
          <hr/>
          <div className='mt-3'>
            <strong>Angewendete Rabattcodes:</strong>
            <ul>
              {discountCodes.map(code => (
                <li key={code.code}>{code.code}</li>
              ))}
            </ul>
          </div>
        </>
      )}
    </>
  )
}

export default PaymentDetails
